import { MembershipProductType } from "../Types/MembershipProductType";

export interface MembershipProductTypeOption {
    value: number;
    textKey: string;
}

export const MembershipProductTypeOptions: MembershipProductTypeOption[] = [
    {
        value: MembershipProductType.Addon,
        textKey: 'MembershipProducts_ProductTypeAddon'
    },
    {
        value: MembershipProductType.MembershipType,
        textKey: 'MembershipProducts_ProductTypeMembership'
    },
];